var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 31,
    rx: 4,
    fill: "#19AA59"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29,
    r: 5.5,
    fill: "white",
    stroke: "#19AA59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.792 26.4C26.2613 26.4 26.672 26.4507 27.024 26.552V27.712C27.0027 27.7013 26.9493 27.68 26.864 27.648C26.7787 27.616 26.6613 27.5867 26.512 27.56C26.368 27.528 26.2107 27.512 26.04 27.512C25.6987 27.512 25.4107 27.5813 25.176 27.72C24.9413 27.8587 24.7653 28.056 24.648 28.312H26.32V29.056H24.472V29.232C24.472 29.328 24.4747 29.3973 24.48 29.44H26.32V30.184H24.656C24.7787 30.44 24.9547 30.6373 25.184 30.776C25.4187 30.9147 25.704 30.984 26.04 30.984C26.2107 30.984 26.368 30.968 26.512 30.936C26.6613 30.904 26.7787 30.872 26.864 30.84C26.9493 30.8027 27.0027 30.7787 27.024 30.768V31.896C26.592 32.0293 26.1733 32.096 25.768 32.096C25.3947 32.096 25.0213 32.0373 24.648 31.92C24.28 31.7973 23.9467 31.5947 23.648 31.312C23.3493 31.024 23.136 30.648 23.008 30.184H22.184V29.44H22.904V29.056H22.184V28.312H23.008C23.1947 27.6347 23.5467 27.1467 24.064 26.848C24.5867 26.5493 25.1627 26.4 25.792 26.4Z",
    fill: "#19AA59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 17,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/Catalog.ce8a4b83bf4eacd4f0ceb60f7238effc.svg";
export { ForwardRef as ReactComponent };